<template>

  <div id="app">
    <a-locale-provider :locale="zh_CN">
    </a-locale-provider>
    <router-view/>
  </div>
</template>

<script>
// eslint-disable-next-line camelcase
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
// eslint-disable-next-line import/no-extraneous-dependencies,no-unused-vars
import moment from 'moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'moment/locale/zh-cn';

export default {
  data() {
    return {
      zh_CN,
    };
  },
  mounted() {
    window.addEventListener('unload', this.saveState);
  },
  methods: {
    saveState() {
      sessionStorage.setItem('state', JSON.stringify(this.$store.state));
    },
  },
};
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
th.week-num-col ,td.week-num-col{
  /*width: 20px !important;*/
  padding: 4px 3px !important;
  /*text-align: right !important;*/
}
th.user-name-col, td.user-name-col {
  min-width: 50px !important;
}
.ant-tabs-ink-bar-animated{
  z-index: auto !important;
}
/*td.column-service-hours {*/
/*  text-align: center !important;*/
/*}*/
@media (min-width: 576px){
  .ant-col-sm-8 {
    width: 23.33333333% !important;
  }
}
.ant-card-body {
  padding: 18px !important;
  zoom: 1;
}
</style>
